<div class="flex flex-col rounded-2xl bg-gray-000">
	<div class="flex flex-col items-center gap-1.5 px-4 pb-4 pt-2">
		<div class="flex w-full items-center justify-between text-xs text-gray-700">
			<ui-number
				format="1.0-0"
				class="cursor-pointer"
				[value]="candleData().highAllowedPrice"
				[attr.aria-label]="'آستانه بالای قیمت'"
				(click)="onReferencePriceClick(candleData().highAllowedPrice)" />
			<ui-number
				format="1.0-0"
				class="cursor-pointer"
				[value]="candleData().previousClosePrice"
				[attr.aria-label]="'قیمت پایانی روز قبل'"
				(click)="onReferencePriceClick(candleData().previousClosePrice)" />
			<ui-number
				format="1.0-0"
				class="cursor-pointer"
				[value]="candleData().lowAllowedPrice"
				[attr.aria-label]="'آستانه پایین قیمت'"
				(click)="onReferencePriceClick(candleData().lowAllowedPrice)" />
		</div>
		<div class="relative flex flex-col items-center w-full">
			@if (candleData().lastPrice) {
				<ui-icon
					width="10"
					height="10"
					class="candle-motion pointer-events-none text-gray-700 absolute -top-1 z-10 -translate-x-1/2"
					iconName="caret-down-fill"
					[style.left]="lastPricePercent() + '%'" />
				<ui-icon
					width="10"
					height="10"
					class="candle-motion pointer-events-none text-gray-700 absolute top-3.5 z-10 -translate-x-1/2"
					iconName="caret-up-fill"
					[style.left]="closingPricePercent() + '%'" />
			}

			<div class="flex items-center justify-between w-full text-stroke-100">
				@for (item of [1, 2, 3]; track $index) {
					<svg width="1" height="7" viewBox="0 0 1 7" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M1 4L1 7H0L1.31134e-07 4H1Z" fill="currentColor" />
						<path d="M1 0L1 3H0L1.31134e-07 0H1Z" fill="currentColor" />
					</svg>
				}
			</div>
			@if (showTooltip()) {
				<div
					#tooltipEl
					class="pointer-events-none absolute bottom-4.5 z-20 flex gap-1 items-center justify-between text-2.75 p-1.5 rounded-lg border border-stroke-100 bg-gray-000 -translate-x-1/2 shadow-sm tooltip-arrow"
					[style.left]="tooltip().tooltipPosition"
					[style.--tooltip-arrow-left]="tooltip().tooltipArrowPosition">
					<span
						class="whitespace-nowrap"
						[class.text-green-500]="tooltip().tooltipPercent > 0"
						[class.text-red-500]="tooltip().tooltipPercent < 0">
						(%<ui-number dir="ltr" [maxDigit]="2" [minDigit]="2" [value]="tooltip().tooltipPercent" />)
					</span>
					<ui-number format="1.0-0" class="text-gray-900" [value]="tooltip().tooltipPrice" />
				</div>
			}
			<div
				#priceBar
				class="price-bar"
				(pointercancel)="onPriceBarPointerCancel()"
				(pointerdown)="onPriceBarPointerDown($event)"
				(pointerleave)="onPriceBarPointerLeave($event)"
				(pointermove)="onPriceBarPointerMove($event)"
				(pointerup)="onPriceBarPointerUp($event)">
				<div
					role="slider"
					tabindex="0"
					aria-label="انتخاب قیمت"
					class="price-knob"
					[attr.aria-valuemin]="candleData().lowAllowedPrice"
					[attr.aria-valuemax]="candleData().highAllowedPrice"
					[attr.aria-valuenow]="knobPrice()"
					[style.left.%]="knobPercent()"
					(blur)="hideTooltip()"
					(keydown)="onKnobKeydown($event)">
					<span class="size-0.5 rounded-full bg-gray-700"></span>
				</div>
				<div class="relative w-full h-0.5 bg-stroke-100">
					<div
						class="candle-motion absolute h-0.5 bottom-0"
						[class.bg-green-500]="isBullish()"
						[class.bg-red-500]="!isBullish()"
						[style.left.%]="shadowShapePosition().left"
						[style.right.%]="shadowShapePosition().right"></div>
					<div
						class="candle-motion absolute rounded-xs h-2 -bottom-0.75"
						[class.bg-green-500]="isBullish()"
						[class.bg-red-500]="!isBullish()"
						[style.left.%]="bodyShapePosition().left"
						[style.right.%]="bodyShapePosition().right"></div>
				</div>
			</div>
		</div>
	</div>

	<div
		class="overflow-hidden transition-[max-height] duration-400 ease-in-out"
		[class.max-h-36]="isExpanded()"
		[class.max-h-0]="!isExpanded()">
		<div class="flex flex-col px-3">
			@for (item of priceDetails(); track item.label) {
				<div
					class="flex h-9 w-full items-center justify-between gap-2 border-stroke-100 text-3.25 font-medium text-gray-900"
					[class.border-t]="!$first">
					<span>{{ item.label }}:</span>
					<ui-number class="pt-1" format="1.0-0" [value]="item.value" />
				</div>
			}
		</div>
	</div>

	@if (showHelp()) {
		<div class="relative flex items-center justify-center px-3 py-1" (click)="toggleExpanded()">
			<ui-icon
				width="18"
				height="18"
				class="absolute left-3 text-blue-500 cursor-pointer"
				iconName="question-box"
				aria-label="راهنمای نمودار کندل"
				(click)="openCandleInfoBottomSheet($event)" />

			<ui-icon
				width="22"
				height="22"
				class="text-gray-900 cursor-pointer"
				[iconName]="isExpanded() ? 'chevron-up' : 'chevron-down'" />
		</div>
	}
</div>

@if (showHelp()) {
	<app-bottom-sheet #candleInfoBottomSheet ariaLabel="راهنمای نمودار کندل">
		<ng-template #body>
			<div class="flex flex-col items-center gap-2 p-3">
				<img
					width="250"
					height="210"
					loading="eager"
					alt="راهنمای نمودار کندل"
					[ngSrc]="candleHelpImageSrc()" />
				<ui-button
					variant="blue"
					model="outline"
					size="md"
					class="w-full"
					extraButtonClasses="h-9 w-full"
					data-cy="candle-help-learn-more"
					(clicked)="openCandleLearningPage()">
					برای اطلاعات بیشتر کلیک کنید
				</ui-button>
			</div>
		</ng-template>
	</app-bottom-sheet>
}
